module.exports = __webpack_public_path__ + "static/media/view event.9d0ef711.svg";